import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { ProposalsService } from 'src/app/services/api/proposals.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-payment-terms-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './payment-terms-index-page.component.html',
  styleUrl: './payment-terms-index-page.component.scss'
})
export class PaymentTermsIndexPageComponent {
  ist: any[] = [];
  
    baseIndexPageConfig: BaseIndexPageConfig;
  
    constructor(
      protected proposalsService: ProposalsService,
      private routeService: RouteService
    ) {
      this.baseIndexPageConfig = {
        pageTitle: 'Payment Terms',
        cardTitle: 'Manage Payment Terms',
        addNewItemButton: {
          type: 'success',
          title: 'Add Payment Terms',
          onClick: () => {
            this.routeService.proposalPaymentTermsCreate()
          }
        },
        dataTable: {
          data: [],
          searchModel: {
            userId: null,
            firstName: null,
            lastName: null,
          },
          pagination: null,
          columns: [
            new DataTableColumnText({
              attribute: 'code',
              header: 'Code',
              filter: 'text',
              value: (item: any) => {
                return item.code;
              }
            }),
            new DataTableColumnText({
              attribute: 'name',
              header: 'Name',
              filter: 'text',
              value: (item: any) => {
                return item.name;
              }
            }),          
            new DataTableColumnActions({
              header: 'Actions',
              attribute: 'actions',
              style: { width: '50px' },
              buttons: [
                {
                  icon: 'fa-eye',
                  tooltip: 'View proposal payment term details',
                  onClick: (item: any) => {
                    this.routeService.proposalPaymentTermsDetail(item.proposalPaymentConditionTypeId)
                  }
                },
                {
                  icon: 'fa-edit',
                  tooltip: 'Edit proposal payment term',
                  onClick: (item: any) => {
                    this.routeService.proposalPaymentTermsUpdate(item.proposalPaymentConditionTypeId)
                  }
                },
                {
                  icon: 'fa-trash',
                  tooltip: 'Delete proposal payment term',
                  onClick: (item: any) => {                  
                    this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((proposalPaymentTerm: any) => proposalPaymentTerm.proposalPaymentConditionTypeId !== item.proposalPaymentConditionTypeId);
                  },
                  isDelete: true
                },
  
              ]
            })
          ]
        },
        apiListService: (options: ApiOptionsConfig) => this.proposalsService.listSettingsPaymentTerms(options),
        responseListModelName: 'proposalPaymentConditionTypes',
      }
    }
}
